import { UIRouter } from '@wix/tpa-router';
import type { ControllerParams } from '@wix/yoshi-flow-editor';
import { IAppData } from 'src/types';

export function listenEditorPageChange(
  router: UIRouter,
  params: ControllerParams,
) {
  const { flowAPI } = params;
  const { isEditor, isPreview } = flowAPI.environment;

  if (!isEditor && !isPreview) {
    return;
  }

  flowAPI.controllerConfig.wixCodeApi.location.onChange((data) => {
    const { verticalsBaseUrls } = params.appData as IAppData;

    // path can be:
    // ['html', 'editor', 'web', 'renderer', 'render', 'document', '1f7eed2a-8764-4518-8703-274022cb4691', 'group', 'release-notes', 'discussion']
    // ['editor', 'web', 'renderer', 'render', 'document', '1f7eed2a-8764-4518-8703-274022cb4691', 'group', 'release-notes', 'discussion']
    // ...
    // and only if the last 3 segments of the path are 'group', '<group-id>', '<tab-name>' we can proceed
    const [groupBaseUrl, slug] = data.path.slice(-3);

    if (groupBaseUrl === verticalsBaseUrls.group.replace(/^\//, '')) {
      if (slug) {
        router.stateService.go('group', { slug });
      }
    }
  });
}
